export default __webpack_public_path__ + "e3a21551671ece3610b76726a6e3dd97.png";